import {setDefaults} from '@/router/helper';

import _ from "lodash";

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const routes = [
  {
    path: 'manageInvoice',
    name: 'manageInvoice',
    meta: {
      title: '订单发票',
    },
    component: _import('manageCenter/manageInvoice.vue'),
  },
  {
    path: ':id',
    name: 'manageInvoiceDtl',
    meta: {
      title: '发票详情',
      radioGroup: 'manageInvoiceDtl',
    },
    component: _import('manageCenter/managementInvoiceDetails.vue'),
    children: _.map([
        {
          path: '',
          name: 'baseInvoice',
        },
      ], (r) => _.defaultsDeep(r, {
        name: r.path,
        meta: {
          radioGroup: 'manageInvoiceDtl',
          title: '发票详情',
        },
      }),
    ),
  },
];

const setDefaultMeta = (prefix) => (r) => {
  const newRoute = {
    ...r,
    path: `${prefix}${r.path}`,
    meta: _.defaults({
      auth: true,
    }, r.meta),
  };
  if (_.isArray(r.children) && !_.isEmpty(r.children)) {
    newRoute.children = _.map(r.children, setDefaultMeta(''));
  }
  return newRoute;
};

export default _.map(routes, setDefaultMeta('Invoices/'));
